import React,{useRef} from 'react';
import Inputs from '../../../Components/Inputs/Inputs';
import Icons from '../../../Components/Icons/Icons'; 

const RightContent = (props) => {
	const {processLine,newProcessLine,getAutomationProcessLines,tableRecords,goToLine,goToLineChangeHandler,goToProcessLine,editLineHandler,deleteLineHandler} = props;
	console.log('processLine==',processLine)
	const KeyCodes = {
	    comma: 188,
	    enter: 13,
	};
  const delimiters = [KeyCodes.comma, KeyCodes.enter];

	const listInnerRef = useRef();
	const onScroll = () => {

    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      // console.log(scrollTop + clientHeight,scrollHeight);
      if ((scrollTop+1) + clientHeight === scrollHeight) {
        // console.log(scrollTop, clientHeight, 'Reached bottom',scrollHeight);
        getAutomationProcessLines(tableRecords.pagination,true);
      }
    }
	}

	const handleKeyDown = (event) => {   
    if (delimiters.indexOf(event.keyCode) !== -1 ) {
        goToProcessLine();
    }
  }

  let withoutExistProcessLine = [];
  if(newProcessLine && newProcessLine.length>0) {
  	newProcessLine.map(item => {
  		if(item.isExist !== true) {
  			withoutExistProcessLine.push(item);
  		}
  	})
  }

  let totalSavedRecords = tableRecords.pagination.totalRecords;
	return (
		<div className="view" style={{"width": "50%"}}>
		{ withoutExistProcessLine && withoutExistProcessLine.length>0 ? 
			<div className="filter_Box no-bd" style={{"max-height": "30%"}}>
				<div className="filter_Header  p-2">
					<label> New Lines </label>
				</div>
				<div className="filter_Body p-0 bg-white">
					<ol className="lines-feed">
						{
							withoutExistProcessLine.map((item,ind) => {
								return (
									item.isExist === false ? 
									<li className="feed-item feed-item-default IsAdded" key={ind}>
										<label className="date"> Line {totalSavedRecords+(ind+1)} </label>
										<span className="text-medium">
											<div className="pb-0">
	                  		[<span> Keywords: <code className="pl-1"> {item.keyword_name}  </code> </span>] <span className="text-muted text-large text-bold">,</span> 
												[<span> Keywords Value: <code className="pl-1"> {item.keyword_values ? JSON.stringify(item.keyword_values) : ''} </code> </span>] <span className="text-muted text-large text-bold">,</span> 
												[<span> Expression: <code className="pl-1"> {item.expression} </code> </span>]
											</div>	
						                </span>
									</li>
									: null
								)
							})
						}
					</ol>														 
				</div>
			</div> 
			: null }
			<div className="filter_Box no-bd" style={{"max-height": withoutExistProcessLine.length>0 ? "70%" : "100%"}}>
				<div className="filter_Header  p-1">
					<div className="d-flex align-items-center justify-content-between">
						<label> Saved Lines  <span className="badge badge-warning secondary_color"> {totalSavedRecords} </span></label>
						<div className="input-group col-6 pr-0">
							<input type="text" name="goToLine" 
								className="form-control form-control-sm" 
								placeholder="Enter the line no to access quickly" 
								autocomplete="off" 
								value={goToLine}
								onChange={goToLineChangeHandler}
								onKeyDown={handleKeyDown} />
							<div className="input-group-append">
								<a className="btn primary_bg " onClick={goToProcessLine}> Go </a>
							</div>
						</div>
					</div>
				</div>
				<div className="filter_Body p-0 bg-white" onScroll={() => onScroll()} ref={listInnerRef}>
					<ol className="lines-feed">
						{
							processLine && processLine.length>0 ? 
								processLine.map((item,ind) => {
									return (
										<li className={item.active === true ? "feed-item feed-item-secondary IsActive" : "feed-item feed-item-secondary IsInActive"} key={ind}>
											<div className="d-flex align-items-center justify-content-between">
												<label className="date"> Line {item.line_number} </label>
												<a className="pl-2 cursor-pointer mb-1" onClick={e=>deleteLineHandler(item.id)}><Icons iconType="Delete" /></a>
											</div>											
											<span className="text-medium" onClick={e=>editLineHandler(item,ind)}>
												<div className="pb-0 p-1">
													[<span> Conditional Keywords: <code className="pl-1"> {item.conditional_keyword}  </code> </span>] <span className="text-muted text-large text-bold">,</span> 
													[<span> Pre Condition: <code className="pl-1"> {item.pre_condition}  </code> </span>] <span className="text-muted text-large text-bold">,</span> 
		                  							[<span> Keywords: <code className="pl-1"> {item.keyword_name}  </code> </span>] <span className="text-muted text-large text-bold">,</span> 
													[<span> Keywords Value: <code className="pl-1"> {item.keyword_values ? JSON.stringify(item.keyword_values) : ''} </code> </span>] <span className="text-muted text-large text-bold">,</span>
													[<span> Expression: <code className="pl-1"> {item.expression} </code> </span>] 
												</div>	
			                </span>			                
										</li>
									)
								})
							: null
						}
					</ol>														 
				</div>
			</div> 
		</div>
	)
}

export default RightContent;